import { DateTime } from "luxon";

export function isoDate(date?: Date | DateTime): string {
  if (date instanceof DateTime) {
    return date.toJSDate().toISOString();
  }

  return (date ?? new Date()).toISOString();
}
